/* src/app/layout/container-standard/container-standard.component.css */
.content {
  padding: 20px;
  width: 100%;
  background: white;
}
.container {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding-right: 0;
  padding-left: 0;
  overflow: hidden;
}
@media only screen and (min-width: 500px) {
  .container {
    border-radius: 0px;
  }
}
@media only screen and (min-width: 500px) {
  .main-content {
    margin: 20px !important;
  }
}
.main-content {
  margin: 0px;
}
.gray {
  background-color: var(--gray);
}
.title-bar {
  text-align: center;
}
.title {
  color: var(--translucent);
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  padding-top: 25px;
  padding-bottom: 20px;
}
/*# sourceMappingURL=container-standard.component.css.map */
